var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.036 41.036"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "m37.5 37.5-9-9"
  }))));
};
export { SvgSearch as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MS4wMzYgNDEuMDM2Ij4KICA8ZyBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI1Ij4KICAgIDxnPgogICAgICA8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTcuNSIgcj0iMTcuNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxjaXJjbGUgY3g9IjE3LjUiIGN5PSIxNy41IiByPSIxNSIvPgogICAgPC9nPgogICAgPHBhdGggc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMzcuNSAzNy41bC05LTkiLz4KICA8L2c+Cjwvc3ZnPg==";